import { Client } from 'utils'


const { REACT_APP_MICROSERVICES_DOMAIN } = process.env


const api = new Client({
  accept: 'application/json',
  apiURL: REACT_APP_MICROSERVICES_DOMAIN,
})

export const getExternalContent = (hash, repository) => api.client.get(`/content/external-content/external/${repository}/${hash}`)
